<template>
  <div id="app">
    <topbar></topbar>
    <router-view/>
    <bottombar/>
  </div>
</template>
<script>
// Components
import Topbar from '@/components/Topbar/Topbar'
import Bottombar from '@/components/Bottombar/Bottombar'
export default {
  name: 'App',
  components: { Topbar, Bottombar }
}
</script>
<style lang="sass">
  @import 'assets/sass/app';
</style>



// WEBPACK FOOTER //
// src/App.vue